import React, { useEffect, useState } from "react";
import { BsCardList } from "react-icons/bs";
import { FiXSquare, FiCheckSquare } from "react-icons/fi";
import { PiCreditCardDuotone } from "react-icons/pi";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";


const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/invoice_coustomer_list"
      );
      if (response.data.status) { // status is boolean
        setInvoices(response.data.data); // data contains the array
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      toast.error("Error fetching invoices");
    }
  };

  fetchInvoices();
}, []);


  const deleteUser = async (invoiceId) => {
  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_invoice",
      { invoice_id: invoiceId },
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data.status === "true") {
      setInvoices(prev => prev.filter(inv => inv.invoice_id !== invoiceId));
      toast.success(response.data.message || "Invoice Deleted Successfully!");
    } else {
      toast.error(response.data.error || "Delete failed.");
    }
  } catch (error) {
    console.error("There was an error!", error);
    toast.error("Failed to delete invoice.");
  }
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Invoices List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Invoices</a>
                </li>
                <li className="breadcrumb-item active">Invoices List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Invoice Summary Cards */}
        <div className="row">
          {[
            { title: "Total Invoice", count: invoices.length, icon: <BsCardList className="fs-32 text-primary avatar-title" /> },
            {
              title: "Pending Invoice",
              count: invoices.filter(i => i.status === "Pending").length,
              icon: <FiXSquare className="fs-32 text-primary avatar-title" />
            },
            {
              title: "Paid Invoice",
              count: invoices.filter(i => i.status === "Completed" || i.status === "Paid").length,
              icon: <FiCheckSquare className="fs-32 text-primary avatar-title" />
            },
            {
              title: "Inactive Invoice",
              count: invoices.filter(i => i.status === "Inactive").length,
              icon: <PiCreditCardDuotone className="fs-32 text-primary avatar-title" />
            }
          ].map((card, index) => (
            <div className="col-lg-3" key={index}>
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title mb-2 d-flex align-items-center gap-2">
                        {card.title}
                      </h4>
                      <p className="text-muted fw-medium fs-22 mb-0">{card.count}</p>
                    </div>
                    <div>
                      <div className="avatar-md bg-primary bg-opacity-10 rounded">
                        {card.icon}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Invoice Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <h4 className="card-title">All Invoices List</h4>
                <div className="dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    This Month
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a href="#!" className="dropdown-item">Download</a>
                    <a href="#!" className="dropdown-item">Export</a>
                    <a href="#!" className="dropdown-item">Import</a>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check fs-16 ms-1">
                            <input type="checkbox" className="form-check-input" id="customCheck1" />
                            <label className="form-check-label" htmlFor="customCheck1" />
                          </div>
                        </th>
                        <th>Invoice ID</th>
                        <th>Billing Name</th>
                        <th>Order Date</th>
                        <th>Total</th>
                        <th>Payment Method</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices.map((invoice, idx) => (
                        <tr key={invoice.id}>
                          <td>
                            <div className="form-check fs-16 ms-1">
                              <input type="checkbox" className="form-check-input" id={`customCheck${idx}`} />
                              <label className="form-check-label" htmlFor={`customCheck${idx}`}>&nbsp;</label>
                            </div>
                          </td>
                          <td>
                            <a href="javascript: void(0);" className="text-body">{invoice.invoice_id}</a>
                          </td>
                          <td>
                            {invoice.customer_name}
                          </td>
                          <td>{new Date(invoice.created_at).toLocaleDateString("en-GB")}</td>
                          <td>${invoice.total_amount}</td>
                          <td>{invoice.payment_method}</td>
                          <td>
                            <span className={`badge ${invoice.status === "Completed" ? "bg-success-subtle text-success" : invoice.status === "Pending" ? "bg-warning-subtle text-warning" : "bg-danger-subtle text-danger"} py-1 px-2`}>
                              {invoice.status}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                  to={`/invoice-detail/${invoice.invoice_id}`}
                                  className="btn btn-light btn-sm"
                                >
                                  <i className="fa-solid fa-eye align-middle fs-18"></i>
                                </Link>
                              <a href="#!" className="btn btn-soft-primary btn-sm">
                                <i className="fa-solid fa-pencil align-middle fs-18"></i>
                              </a>
                              <span
                                  onClick={() => deleteUser(invoice.invoice_id)}
                                  className="btn btn-soft-danger btn-sm"
                                >
                                  <i class="fa-solid fa-trash align-middle fs-18"></i>
                                </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Pagination */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">Previous</a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">1</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">Next</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon icon="iconamoon:heart-duotone" className="fs-18 align-middle text-danger" />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">Techzaa</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default InvoiceList;
